import React, { Component } from 'react';
import { 
    Form, 
    Input, 
    Button, 
    Typography, 
    Card,
} from 'antd';
import { Redirect } from 'react-router-dom';
import StatusMessage from '../../StatusMessage';
import { required } from '../../../constants/formValidation';


const { Paragraph } = Typography;

class LoginForm extends Component {
    handleSubmit = e => {
        const { form, handleLoginUser } = this.props;

        e.preventDefault();

        form.validateFields((err, { email, password }) => {
            if (err) return;

            handleLoginUser(email, password);
        });
    }

    render() {
        const {
            isLoading,
            isLoginSuccess,
            loginFailMessage,
            form,
        } = this.props;
        const { getFieldDecorator } = form;

        if (isLoginSuccess) {
            return <Redirect to="/dashboard" />;
        }

        return (
            <Card
                style={{ width: 360, textAlign: 'center' }}
                actions={[
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={isLoading}
                        onClick={this.handleSubmit}
                    >
                        Login
                    </Button>
                ]}
            >
                <Paragraph strong>
                    Log in to your account
                </Paragraph>
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item>
                        {
                            getFieldDecorator('email', required())(
                                <Input placeholder="Email Address" />
                            )
                        }
                    </Form.Item>
                    <Form.Item>
                        {
                            getFieldDecorator('password', required())(
                                <Input.Password placeholder="Password" />
                            )
                        }
                    </Form.Item>
                    {
                        loginFailMessage &&
                        <StatusMessage variant="error" message={loginFailMessage} />
                    }
                </Form>
            </Card>
        );
    }
}

export default Form.create({ name: 'login' })(LoginForm);
